import React from 'react';
import AppLayout from '../components/AppLayout';
import OverviewList,{MiniList} from '../components/OverviewList';
import {PageMenu,DeleteListItem,GenerateSpreadsheet,BulkEdit,AddListItem,DynamicListArea,DownloadTemplate,LoadGraphic,Step,Segment,SegmentComplete} from '../components/Common';
import {Button,Box,EditSizeLabel,EditSizeLink,TextButton,ContactNumber,Checkbox,Input} from '../components/Input';
import u from '../utilities/Utilities';
import PropTypes from 'prop-types';
import moment from 'moment';
import qs from 'query-string';
import {Link} from 'react-router-dom';
import store from 'store';

export default class AbsenceReasonList extends React.Component{

    settings={
        /**** Page Setup ****/
        title:"Absence Reason",
        permission:"resident",
        url:"/absence-reason-list",

        /**** Action Setup ****/
        addType:0,
        addURL:"/api/add-absence-reason-entry",
        bulkURL:"/api/add-bulk-absence-reason-entries",
        templateURL:"/api/get-add-absence-reason-template",
        deleteURL:"/api/delete-absence-reason-entries",
        spreadsheetURL:"/api/generate-absence-reason-spreadsheet",
        overviewURL:"/api/get-all-absence-reason-entries",

        /**** List Setup ****/
        list:true,
        listLabel:"absence-reason-list",
        orderByField:"createdOn",
        orderByType:"descending",
        numRows:20,
        checkboxPermissions:{},
        overview:undefined,
        onPopup:(content)=>{this.refs['layout'].onPopup(content)}
    };

    state={
        selected:{
            tags:[],
            all:false,
            data:[],
            entryCount:0
        },
        pageMenuButtons:[],
        addError:"",
        permissions:{},
    };

    componentDidMount=()=>{
        const permissions = u.getPermissions(this.settings.permission);
        const bulkEditOptions = u.getBulkEdit(this.settings.listLabel);
        const bulkEditEnabled = (permissions.update == 2 && bulkEditOptions.length > 0);
        const query = qs.parse(this.props.location.search);
        this.setState({
            permissions:permissions,
            pageMenuButtons:[
              {label:"Add",ref:"add",mobileLabel:"Add Entry",title:"Add new entry",enabled:(permissions.update==2)},
              {label:"Delete",ref:"delete",mobileLabel:"Delete Entries",title:"Delete selected entries",enabled:(permissions.update==2)},
              {label:"Spreadsheet",ref:"spreadsheet",mobileLabel:"Generate Spreadsheet",title:"Generate spreadsheet from selection",enabled:true},
              {label:"Bulk Edit",ref:"bulkEdit",mobileLabel:"Bulk Edit",title:"Bulk edit details",enabled:bulkEditEnabled,padding:"3px"},
            ],
            createRequest:query.create,
        });
    }

    onSelectChange=(selected)=>{
        this.setState({selected:selected});
    }

    render=()=>{
        const pageComponents={
            add:{component:AddEntry,props:{create:this.state.createRequest}},
            delete:{component:DeleteListItem,props:{}},
            spreadsheet:{component:GenerateSpreadsheet,props:{}},
            bulkEdit:{component:BulkEdit,props:{}},
        };

        return (
            <AppLayout ref="layout" settings={this.settings}>

                <div className="page-error-container">
                    <div className="page-error">{this.state.error}</div>
                </div>

                <PageMenu settings={this.settings}
                          buttons={this.state.pageMenuButtons}
                          components={pageComponents}
                          selected={this.state.selected}/>

                <OverviewList ref={(ref)=>{this.settings.overview=ref}}
                              settings={this.settings}
                              onSelectChange={this.onSelectChange}
                              registerReference={this.registerReference}
                              onMutatedChange={this.onMutatedChange}
                              location={this.props.location}>
                    {
                        (content,index,onChange,onContentChange,registerRef)=>{
                            return (
                                <AbsenceReasonItem key={index}
                                                   content={content}
                                                   index={index}
                                                   onChange={onChange}
                                                   onContentChange={onContentChange}
                                                   registerReference={registerRef}
                                                   settings={this.settings}
                                                   />
                            )
                        }
                    }
                </OverviewList>

            </AppLayout>
        )
    }
}

export class MiniAbsenceReasonList extends React.Component{

    settings={
        /**** Page Setup ****/
        title:"Absence Reason",
        permission:"resident",  //Accepts combined permission module as well
        //combinedField:"",     //Used when permission exists in a combined field
        url:"/absence-reason-list",
        overviewURL:"/api/get-all-absence-reason-entries",
        spreadsheetURL:"/api/generate-absence-reason-spreadsheet",

        /**** List Setup ****/
        listLabel:"absence-reason-list",
        orderByField:"createdOn",
        orderByType:"descending",
        //detailsLink:"/absence-reason-list/", //Leave null if linking to list
    };

    refresh=()=>{
        this.refs['list'].refresh();
    }

    render=()=>{
        return(
            <MiniList ref="list"
                      settings={this.settings}
                      tags={this.props.tags}
                      pageLength={this.props.pageLength}
                      orderByField={this.props.orderByField}
                      orderByType={this.props.orderByType}
            />
        )
    }
}

class AbsenceReasonItem extends React.Component{
    render=()=>{
        const content = this.props.content;
        return (
            <div>
                <DynamicListArea listLabel={this.props.settings.listLabel}
                                 permission={this.props.settings.permission}
                                 content={this.props.content}
                                 onChange={this.props.onChange}
                                 index={this.props.index}
                                 />
            </div>
        )
    }
}

class AddEntry extends React.Component{

    state={
        options:{},
        entryData:{},
        dormOptions:[],
        sickbayOptions:[],
        sickbedOptions:[],
        popup:false,
        poppedup:false,
    };

    show=(show)=>{
        this.refs[this.props.reference].show(show);
    }

    componentDidMount=()=>{
        this.getOptions();
    }

    static getDerivedStateFromProps(props,state){
        if(props.create && !state.popup){
            state.popup=true;
        }
        return state;
    }

    componentDidUpdate=()=>{
        if(this.state.popup && !this.state.poppedup){
            let entryData=this.state.entryData;
            entryData.tenantNRIC = this.props.create;
            this.setState({poppedup:true});
            this.props.onToggleForm(this.props.reference,true);
        }
    }

    getOptions=()=>{
        u.post({
            url:"/api/get-estate-options",
            data:{
                type:"dorm"
            },
            success:(dormOptions)=>{
                if(this.props.dormID){
                    dormOptions = dormOptions.filter(opt => opt.value == this.props.dormID);
                }

                this.setState({dormOptions:dormOptions});
            },
            error:(error)=>{
                this.setState({error:error});
            }
        });

        u.post({
            url:"/api/get-options",
            data:{
              keys:["absenceReason"]
            },
            success:(options)=>{
                this.setState({options:options});
            },
            error:(error)=>{
                this.setState({error:error});
            }
        });
    }

    getSickbayOptions=()=>{
        u.post({
            url:"/api/get-sickbay-options",
            data:{
              dormID:this.state.entryData.dormID,
              onlyVacant:true,
            },
            success:(sickbayOptions)=>{
                this.setState({sickbayOptions:sickbayOptions});
            },
            error:(error)=>{
                this.setState({error:error});
            }
        });
    }

    onChange=(value,label,index,option)=>{
        let entryData=this.state.entryData;
        entryData[label] = value;
        if(label=="absenceReason" && value == "Sickbay" || label=="dormID" && entryData.absenceReason=="Sickbay"){
            this.getSickbayOptions();
        }
        if(label == "sickbayID"){
            this.setState({sickbedOptions:option.bedOptions});
        }
        this.setState({entryData:entryData});
    }

    onCancel=()=>{
        this.props.onToggleForm(this.props.reference,false);
    }

    onComplete=()=>{
        this.setState({entryData:{}});
        this.onCancel();
    }

    onValidate=(fields)=>{
      this.setState({error:""});
      let keys = fields.map((item)=>{return item.field});
      let data = {};
      for(var i=0; i<keys.length; i++){
          if(this.refs[keys[i]]){
              const current = this.refs[keys[i]].validate();
              if(!current.valid){
                  this.setState({error:current.value});
                  return 0;
              }
              data[keys[i]] = current.value;
          }
      }
      //Additional validation
      if(moment(data.startDate).isSameOrAfter(data.endDate)){
          this.setState({error:"End date must be at least 1 day after start date"});
          return 0;
      }

      this.refs[this.props.reference].onValidated(data);
    }

    render=()=>{
        const options=this.state.options;
        const fields=[
            {dataType:"select",label:"Dormitory",field:"dormID",options:this.state.dormOptions,disabled:(this.props.dormID)},
            {dataType:"box",label:"Resident FIN",field:"tenantNRIC",rules:{required:true},disabled:(this.props.tenantFIN)},
            {dataType:"date",label:"Start Date",field:"startDate",range:[1,2]},
            {dataType:"date",label:"End Date",field:"endDate",range:[1,2]},
            {dataType:"select",label:"Reason",field:"absenceReason",options:options.absenceReason,rules:{required:true}},
            {dataType:"select",label:"Sickbay",field:"sickbayID",options:this.state.sickbayOptions},
            {dataType:"select",label:"Bed",field:"sickbedID",options:this.state.sickbedOptions},
            {dataType:"box",label:"Departure Flight",field:"departureFlight"},
            {dataType:"date",label:"Departure Date",field:"departureDate",range:[1,2]},
            {dataType:"time",label:"Departure Time",field:"departureTime"},
            {dataType:"box",label:"Departing To",field:"departingTo"},
            {dataType:"box",label:"Arrival Flight",field:"arrivalFlight"},
            {dataType:"date",label:"Arrival Date",field:"arrivalDate",range:[1,2]},
            {dataType:"time",label:"Arrival Time",field:"arrivalTime"},
            {dataType:"box",label:"Departing From",field:"departingFrom"},
            {dataType:"area",label:"Remarks",field:"remarks",rules:{placeholder:"Optional"}},
        ];
        const homeLeaveFields = ["departureFlight","departureDate","departureTime","departingTo","arrivalFlight","arrivalDate","arrivalTime","departingFrom"];
        let entryData=this.state.entryData;
        if(this.props.tenantFIN){
            entryData.tenantNRIC = this.props.tenantFIN
        }

        return(
            <AddListItem ref={this.props.reference}
                         title={"Add Absence Reason"}
                         reference={this.props.reference}
                         settings={this.props.settings}
                         onComplete={this.onComplete}
                         onRefreshList={this.props.onRefreshList}
                         onToggleForm={this.props.onToggleForm}
                         dragAndDropLabel="Accepts templates downloaded from below"
                         >

                <div className="segment-content">
                    <h3>Complete the following</h3>
                    <div style={{margin:"20px auto",fontSize:"0.85em"}}>Smartdorm will automatically toggle the resident's absence on and off on the respective start and end dates</div>
                    {
                        fields.map(
                            (item,index)=>{
                                if((item.field == "sickbayID" || item.field== "sickbedID") && entryData.absenceReason != "Sickbay"){
                                    return (<div key={index}/>)
                                }
                                else if(homeLeaveFields.includes(item.field) && entryData.absenceReason != "Home Leave"){
                                    return (<div key={index}/>)
                                }
                                return(
                                    <Input ref={item.field}
                                           key={index}
                                           fields={{
                                             ...item,
                                             ...{
                                               onChange:this.onChange,
                                               enabled:!(item.disabled),
                                             }
                                           }}
                                           content={entryData}
                                           />
                                )
                            }
                        )
                    }
                    <div style={{fontSize:"0.85em"}}>
                        <TextButton onClick={()=>{this.refs[this.props.reference].onBulkUpload()}}>Bulk Upload</TextButton>
                    </div>
                    <div className="segment-buttons">
                        <div className="segment-error">{this.state.error}</div>
                        {
                            (u.isMobileDevice())
                                ?
                                <Button onClick={this.onCancel}>Cancel</Button>
                                :
                                null
                        }
                        <Button onClick={()=>{this.onValidate(fields)}}>Confirm</Button>
                    </div>
                </div>

            </AddListItem>
        )
    }
}

//Add Entry - For Exported Use
export class AddAbsenceReason extends React.Component{

    settings={
        /**** Action Setup ****/
        addType:0,
        addURL:"/api/add-absence-reason-entry",
        bulkURL:"/api/add-bulk-absence-reason-entries",
        templateURL:"/api/get-add-absence-reason-template",
    };

    show=(show)=>{
        this.refs[this.props.reference].show(show);
    }

    render=()=>{
        return(
            <AddEntry ref={this.props.reference}
                      title="Add Absence Reason"
                      settings={this.settings}
                      reference={this.props.reference}
                      tenantFIN={this.props.tenantFIN}
                      dormID={this.props.dormID}
                      onComplete={this.props.onComplete}
                      onRefreshList={this.props.onRefreshList}
                      onToggleForm={this.props.onToggleForm}
                      />
        )
    }
}
